const { Core, Events } = Global;

const CN_LOADING = '!loading';
const ATTR_VARIANT_ID = 'variant-id';
const ATTR_QUICKSHOP = 'quickshop';
const ATTR_REDIRECT_URL = 'redirect-url';
const TAG_NO_QUICKSHOP = 'no_quickshop';

customElements.define('product-to-cart', class extends Core {
    elements = {
        $: ['to-cart-button']
    }

    propTypes = {
        'form-child': Boolean
    }

    render() {
        this.$({click: this._onClick});
        this.sub(Events.CART_UPDATE, this._cartUpdateHandler, { global: true });
        this.sub(Events.CART_ERROR, this._cartUpdateHandler, { global: true });
    }

    _onClick(e) {
        !this.prop('form-child') && e.preventDefault();

        let no_quickshop = false;
        
        //Exclude from Collection and Search page
        let current_page_url = window.location.href;
        let quickshop_value = this.getAttribute(ATTR_QUICKSHOP);
        let variant_url = this.getAttribute(ATTR_REDIRECT_URL);

        let variant_id = this.getAttribute(ATTR_VARIANT_ID);
        
        if( window.location.href.includes('collections') || window.location.href.includes('search') ){
          if(quickshop_value == 'no'){
            window.location.href=variant_url;
            return;
          }

          //Check tags with Ajax API
          let product_card_media = this.closest('.product-card');
          let product_link_href_tag = product_card_media.querySelector('.stretched-link');
          let product_url = product_link_href_tag.href;
          let product_js_url = product_url + '.js';
  
          fetch(product_js_url)
          .then(response => response.json())
          .then(product => {
            let product_tags = product.tags;
            if(product_tags.includes(TAG_NO_QUICKSHOP)){
              window.location.href=product_url;
              return;
            } else {
              this.loading = true;
              !this.prop('form-child') && this.addToCart(this.cartItem);      
            }
          });
        } else {
          this.loading = true;
          !this.prop('form-child') && this.addToCart(this.cartItem);  
        }
    }

    addToCart(items) {
        this.pub(Events.CART_ADD, {
            items
        });
    }

    _cartUpdateHandler() {
        setTimeout(() => {
            this.loading = false
        }, 1500)
    }

    get cartItem() {
        return [{ 
            id: this.variantId,
            quantity: 1
        }]
    }
    
    set loading(state) {
        this.$('to-cart-button').classList.toggle(CN_LOADING, state);
    }

    set variantId(id) {
        this.setAttribute(ATTR_VARIANT_ID, id)
    }

    get variantId() {
        return +this.getAttribute(ATTR_VARIANT_ID)
    }
})